/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Grade_CodeInputs */

const vi_tea_grade_code = /** @type {(inputs: Tea_Grade_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã`)
};

/**

* @param {Tea_Grade_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_code = /** @type {((inputs?: Tea_Grade_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_code(inputs)
});